import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Media from '@/components/base/media'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'
import { singleMediaRevealAnimation } from '@/components/sections/animations/single-media'
import Spacer from '@/components/sections/spacer'

import { cn } from '@/lib/utils'
import { WPMedia } from '@/types'

type SingleMediaProps = {
  media: WPMedia
  size: 'small' | 'medium' | 'big'
}

const SingleMedia = ({ media, size, ...props }: SingleMediaProps) => {
  return (
    <Motion animation={singleMediaRevealAnimation}>
      {(motionRef) => (
        <Section ref={motionRef} {...props}>
          <Container>
            <Spacer variant="xxl" />
            <Grid>
              <div
                className={cn('col-span-2 md:col-span-6', {
                  'lg:col-span-12': size === 'big',
                  'lg:col-span-8 lg:col-start-3': size === 'medium',
                  'lg:col-span-6 lg:col-start-4': size === 'small'
                })}
              >
                <div
                  data-size={size}
                  data-motion-media
                  className="relative w-full overflow-hidden"
                  style={{
                    aspectRatio: `${media.poster.width} / ${media.poster.height}`
                  }}
                >
                  <Media fit="cover" media={media} data-lightbox />
                </div>
              </div>
            </Grid>
            <Spacer variant="xl" />
          </Container>
        </Section>
      )}
    </Motion>
  )
}

export default SingleMedia
